export class AuthRequiredError extends Error {
  constructor() {
    super('AUTH_REQUIRED')
    this.name = 'AuthRequiredError'
  }
}

type AuthGateOpener = (source?: string) => void

let openAuthGate: AuthGateOpener | null = null

export function registerAuthGateOpener(fn: AuthGateOpener | null): void {
  openAuthGate = fn
}

export function requestAuthGate(source?: string): void {
  openAuthGate?.(source)
}

const PUBLIC_WRITE_PREFIXES = ['/auth/']

export function normalizeApiPath(url: string): string {
  return url.split('?')[0]
}

export function isPublicWritePath(url: string): boolean {
  const path = normalizeApiPath(url)
  return PUBLIC_WRITE_PREFIXES.some((prefix) => path.startsWith(prefix))
}

export function shouldBlockGuestWrite(method: string | undefined, url: string | undefined): boolean {
  const m = (method || 'get').toLowerCase()
  if (!['post', 'put', 'patch', 'delete'].includes(m)) return false
  const path = url || ''
  if (isPublicWritePath(path)) return false
  return true
}

/** Show sign-up modal only for generation or image/video upload for editing. */
export function shouldShowAuthGateForPath(url: string | undefined): boolean {
  if (!url) return false
  const path = normalizeApiPath(url)
  if (path.startsWith('/admin/')) return false

  if (path === '/upload/image') return true
  if (path === '/infographic-editor/upload-video') return true

  if (path.endsWith('/generate')) return true
  if (path.endsWith('/generate-template')) return true
  if (path.endsWith('/generate-image')) return true
  if (path.includes('/remove-background')) return true

  if (/^\/chats\/[^/]+\/generate/.test(path)) return true
  if (/^\/ideogram\/projects\/[^/]+\/generate$/.test(path)) return true

  if (path === '/assistant/chats') return true
  if (path === '/assistant/messages' || path === '/assistant/messages/stream') return true

  return false
}
